// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Attachments from '../../../shared/components/attachments';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledString from '../../../../shared/components/labeled-string';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';

const PipCodeRequestInfo = props =>
    <div className='pip-code-request-info'>
        <div className='row'>
            <LabeledString
                className='dealer-location'
                data={buildDealer(props.pipCodeRequest.dealer)}
                label='DEALER_LOCATION'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='pip-type'
                data={props.pipCodeRequest.pipType.value}
                label='PIP_TYPE'
            />
            <LabeledLink
                className='pip-number'
                data={props.pipCodeRequest.pipNumber}
                href={`#/pips/programs/${props.pipCodeRequest.pipId}`}
                label='PROGRAM_NUMBER'
                rel='noopener noreferrer'
                target='_blank'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='pip-code-status'
                data={props.pipCodeRequest.pipStatus.value}
                label='PIP_STATUS'
            />
            <LabeledString
                className='customer'
                data={props.pipCodeRequest.customerSummary.displayName}
                label='CUSTOMER'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='termination-date'
                data={buildDate(props.pipCodeRequest.terminationDate)}
                label='TERMINATES'
            />
            <LabeledString
                className='expire-date'
                data={buildDate(props.pipCodeRequest.expireDate)}
                label='EXPIRES'
            />
        </div>
        <div className='row'>
            <Attachments files={props.pipCodeRequest.file}/>
            <div className='postal-info'>
                <LabeledString
                    className='postal-tracking-number'
                    data={props.pipCodeRequest.postalTrackingNumber}
                    label='POSTAL_TRACKING_NUMBER'
                />
                <LabeledString
                    className='postage-delivery-date'
                    data={buildDate(props.pipCodeRequest.postalDeliveryDate)}
                    label='POSTAGE_DELIVERY_DATE'
                />
            </div>
        </div>
    </div>;

PipCodeRequestInfo.displayName = 'PipCodeRequestInfo';
PipCodeRequestInfo.propTypes = {
    pipCodeRequest: PropTypes.instanceOf(PipCode).isRequired
};

export default PipCodeRequestInfo;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-request-info.js